/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import { useState } from 'react';

export const EditorsPickLogo = (props: {
  alt: string;
  fallbackText: string;
  fallbackSrc: string;
  primarySrc: string;
}) => {
  const { alt, fallbackText, fallbackSrc, primarySrc } = props;
  const [mediaSrc, setMediaSrc] = useState(primarySrc || fallbackSrc);

  if (!mediaSrc && !fallbackText) {
    return null;
  }

  return (
    <div className="flex h-16 w-[101px] shrink-0 items-center justify-center overflow-hidden rounded-radius/tooltip border border-borders/default p-spacing/padding/soft-12px bg-fill/card">
      {mediaSrc ? (
        <CmsImage
          unoptimized
          src={mediaSrc}
          alt={alt}
          width={101}
          height={64}
          sizes={{ _: 101 }}
          loading="lazy"
          className="size-full object-contain"
          onError={() => {
            if (fallbackSrc && mediaSrc !== fallbackSrc) {
              setMediaSrc(fallbackSrc);
              return;
            }

            setMediaSrc('');
          }}
        />
      ) : (
        <span className="mhg-alpha-typography-caption line-clamp-2 text-center text-text/secondary">
          {fallbackText}
        </span>
      )}
    </div>
  );
};
